import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteShipmentEmail } from "redux/actions/client.action";
import ModalFooterDeleteClose from "../components/ModalFooterDeleteClose";
import ModalBodyDelete from "../components/ModalBodyDelete";

class ShipmentEmailDeleteForm extends React.Component {
  render() {
    const {
      modal: { selectedData },
    } = this.props;
    return (
      <>
        <form>
          <ModalBodyDelete name={selectedData.name} />
          <ModalFooterDeleteClose
            click={() => {
              this.props.deleteShipmentEmail(selectedData.id);
            }}
          />
        </form>
      </>
    );
  }
}
export default connect(
  ({ modal, user }) => ({ modal, user }),
  (dispatch) => bindActionCreators({ deleteShipmentEmail }, dispatch),
)(ShipmentEmailDeleteForm);
